import { useEffect } from 'react';

const useScrollReveal = () => {
  useEffect(() => {
    const revealElements = () => {
      const elements = document.querySelectorAll('.scroll-reveal, .scroll-reveal-left, .scroll-reveal-right, .scroll-reveal-scale');
      
      elements.forEach((element) => {
        const elementTop = element.getBoundingClientRect().top;
        const elementVisible = 150;
        
        if (elementTop < window.innerHeight - elementVisible) {
          element.classList.add('revealed');
        }
      });
    };

    // Initial check
    revealElements();
    
    // Add scroll listener
    window.addEventListener('scroll', revealElements);
    
    return () => {
      window.removeEventListener('scroll', revealElements);
    };
  }, []);
};

export default useScrollReveal;
